import client from './apiClient';

function sendResetPasswordEmail(username, environment, recaptcha) {
  return client('portalPasswords', {
    body: {
      LoginName: username,
      Environment: environment,
      LoginUrl: `${window.location.origin}`,
      RecaptchaResponse: recaptcha,
    },
  });
}

function resetPasswordRequest(password, key) {
  return client('portalpasswords', {
    body: {
      Password: password,
      Key: key,
    },
    method: 'PUT',
  });
}

function getPasswordPolicies() {
  return client('domainpasswordpolicy');
}

export { sendResetPasswordEmail, resetPasswordRequest, getPasswordPolicies };
